/**
 *  logManageMentModule
 *
 * Description  管理配置 日志管理 事件监控 所有队列
 * rebuild:SMG 2016-4-20
 */
'use strict';
angular.module('eventMonitoringAllQueuesModule', ['selectStatusServiceModule'])
    .controller('eventMonitoringAllQueuesCtrl', ['$scope', '$state', '$q', 'trsHttpService', 'selectStatusService', '$timeout', 'modalDialog', 'eventQueuesModalService', function($scope, $state, $q, trsHttpService, selectStatusService, $timeout, modalDialog, eventQueuesModalService) {
        initStatus();
        initData();

        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.status = {
                publishType: selectStatusService.selectType().publishType,
                publishTypeSelected: { name: '全部', value: '0' },
                publishState: selectStatusService.selectType().publishState,
                publishStateSelected: { name: '全部', value: '0' },
                searchWordType: selectStatusService.selectType().searchWordType,
                searchWordSelected: { name: '全部', value: 'TASKTITLE,CRUSER' },
                timeRange: selectStatusService.selectType().timeRange,
                timeRangeSelected: { name: '--请选择--', value: '0' },
                publishType_status: {
                    1: '增量发布',
                    2: '完全发布',
                    5: '更新发布',
                    3: '单篇发布',
                    7: '撤销发布',
                    10: '直接发布',
                    8: '仅发布首页',
                    12: '删除内容同步更新栏目'
                },
                task_status: {
                    5: '正在执行',
                    1: '等待执行',
                    7: '执行成功',
                    9: '执行失败'
                },
                searchWord: '',


            };
            $scope.data = {
                selectedArray: [],
                items: '',
                copyCurrPage: 1
            };
            $scope.params = {
                serviceid: 'mlf_publishtask',
                methodname: 'queryPublishTasks',
                ListAll: true,
                Status: '',
                TimePeriod: '',
                PublishType: '',
                SearchKey: '',
                SearchValue: '',
                StartDate: '',
                EndDate: '',
                AsStartDate: '',
                AsEndDate: '',
                ListScheduled: '',
                PageSize: $scope.page.PAGESIZE,
                PageIndex: $scope.page.CURRPAGE,
            };
        }

        function initData() {
            requestData();
        }

        function requestData() {
            var deffer = $q.defer();
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page = data.PAGER;
                $scope.data.copyCurrPage = data.PAGER.CURRPAGE;
                sumTime();
                deffer.resolve();
            });
            return deffer.promise;
        }

        /** [requestData description]: 页面分页执行操作 */
        $scope.requestData = function() {
            $scope.params.PageIndex = $scope.page.CURRPAGE;
            $scope.params.PageSize = $scope.page.PAGESIZE;
            requestData();
        };

        /**
         * [selectDoc description] 事件队列信息
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openQueuesInfo = function(item){
            eventQueuesModalService.newCreatQueues(item).then(function(){
                requestData();
            });
        };

        /**
         * [tenantJumpToPage description] 跳转到指定页
         * @param {[string]} [attribute1] [description]
         * @param {[string]} [attribute2] [description]
         * tenant
         */

        $scope.jumpToPage = function() {
            $scope.params.PageIndex = $scope.data.copyCurrPage;
            requestData();
        };

        /**
         * [selectAll description]全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.data.selectedArray.length == $scope.data.items.length) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [].concat($scope.data.items);
            }
        };

        /**
         * [selectDoc description]单选
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [tenant selectItem description] 选中下拉菜单
         * @param {[string]} [attribute1] [description]
         * @param {[string]} [attribute2] [description]
         */
        $scope.selectFilterType = function(attribute1, attribute2) {
            $scope.params[attribute2] = $scope.status[attribute1].value;
            requestData();
        };

        /**
         * [queryByDropdown description] 选择日期后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function(key, value) {
            $scope.params.AsStartDate = $scope.data.fromdate == '' ? '' : moment($scope.data.fromdate).format('YYYY-MM-DD 00:00:00');
            $scope.params.AsEndDate = $scope.data.untildate == '' ? '' : moment($scope.data.untildate).format('YYYY-MM-DD 23:59:59');
            requestData();
        };

        /**
         * [tenant searchWord description] 点击搜索
         */
        $scope.searchWord = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                if ($scope.status.searchWordSelected.value == 'TASKTITLE') {
                    $scope.params.SearchKey = 'TASKTITLE';
                    $scope.params.SearchValue = $scope.status.searchWord;
                    requestData();
                } else if ($scope.status.searchWordSelected.value == 'CRUSER') {
                    $scope.params.SearchKey = 'CRUSER';
                    $scope.params.SearchValue = $scope.status.searchWord;
                    requestData();
                } else {
                    $scope.params.SearchKey = 'TASKTITLE,CRUSER';
                    $scope.params.SearchValue = $scope.status.searchWord;
                    requestData();
                }
            }
        };

        /**
         * [sumTime description]共计用时
         * @return {[type]} [description]
         */
        function sumTime() {
            for (var i = 0; i < $scope.data.items.length; i++) {
                var endtime = new Date($scope.data.items[i].ENDTIME.replace(/\-/g, '/'));
                var startime = new Date($scope.data.items[i].STARTTIME.replace(/\-/g, '/'));
                var timeSum = parseFloat(endtime - startime);
                $scope.data.items[i].timeSum = timeSum;
            }
        }

        /**
         * [refresh description]刷新
         * @return {[type]} [description]
         */
        $scope.refresh = function() {
            $state.go($state.current.name, '', { reload: $state.current.name });
        };

        /**
         * [cancelPublish description] 跳出取消发布弹窗
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.cancelPublish = function(item) {
            if (item.TASKSTATUS == '7' || item.TASKSTATUS == '9') {return;}
            modalDialog.alertType('提示信息', '确定取消发布当前任务吗？', 'info', true, function() {
                DeletePublishTask(item);
            }, function() {

            });
        };

        /**
         * [DeletePublishTask description]取消发布当前任务
         * @param {[type]} item [description]
         */
        function DeletePublishTask(item) {
            var params = {
                'serviceid': 'mlf_publishtask',
                'methodName': 'canCelTasks',
                'TaskIds': item.PUBLISHTASKID
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function() {
                requestData();
            });
        }

    }]);
